export default __webpack_public_path__ + "static/char-v-15-ea62cdfda2036993671976f46cb37769.webp";